import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { OidcSecurityService } from 'angular-auth-oidc-client';

import { AlertService } from '../../shared-services/services/alert.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent implements OnInit {

    constructor(private location: Location, private alertService: AlertService, public oidcSecurityService: OidcSecurityService) { }

    ngOnInit() {
    }

    clickLogin() {
        this.oidcSecurityService.authorize();
    }

    clickBack() {
        this.location.back();
    }

    clickLogout() {
        this.oidcSecurityService.logoff();
    }
}
